import "./i18n";
import "./dataDog";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Loading } from "components/shared";
import { setupGlobalEvents } from "./globalEvents";
import reportWebVitals from "./reportWebVitals";
import { createRouter } from "./router";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container!);
const router = createRouter();

setupGlobalEvents();

root.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>,
);

reportWebVitals();
